import React, { useEffect, useState } from "react";
import AdminService from "../../services/AdminService";
export default function AdminOrders() {
  const [orders, setOrders] = useState(null);
  const [trackingIds, setTrackingIds] = useState({});
  useEffect(() => {
    AdminService.getAllOrders().then((res) => {
        setOrders(res.data);
      }).catch((err) => {
        alert(err.message);
      });
  }, []);
  const dispatchOrder = (orderId) => {
    const tid = trackingIds[orderId];
    if (!tid || tid.trim() === "") {
      alert("Tracking ID can't be left empty");
      return;
    }
    AdminService.dispatch(orderId, tid).then((res) => {
        AdminService.getAllOrders().then((res) => {
            setOrders((prev) =>
            prev.map((order) =>
              order.orderId === orderId
              ? { ...order, trackingId: tid, status: "dispatched" }
              : order
            )
            );
        });
      }).catch((err) => {
        alert(err.message);
      });
  };
  const cancelOrder = (orderId) => {
    AdminService.cancelOrder(orderId).then((res) => {
      AdminService.getAllOrders().then((res) => {
        setOrders(res.data);
      });
    }).catch((err) => {
      alert(err.message);
    });
  };
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4 dark:text-white">Orders</h2>
      <div className="flex flex-row m-5">
        <div className="bg-green-300 text-green-700 m-3 px-3 rounded-full">
          Order Type Online
        </div>
        <div className="bg-orange-300 text-orange-700 m-3 px-3 rounded-full">
          Order Type COD
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white dark:bg-gray-700 dark:text-white rounded-lg">
          <thead className="bg-neutral-800 text-white">
            <tr>
              <th className="px-4 py-2">Order ID</th>
              <th className="px-4 py-2">Payment ID</th>
              <th className="px-4 py-2">User Name</th>
              <th className="px-4 py-2">Mobile</th>
              <th className="px-4 py-2">Address</th>
              <th className="px-4 py-2">Items</th>
              <th className="px-4 py-2">Amount</th>
              <th className="px-4 py-2">Status</th>
              <th className="px-4 py-2">Tracking Id</th>
              <th className="px-4 py-2">Dispatch</th>
            </tr>
          </thead>
          <tbody className="dark:bg-neutral-700 dark:text-white">
            {orders &&
              orders.map((order) => (
                <tr key={order.orderId} className={order.orderType==="online" ? "bg-green-300 text-green-700" : "bg-orange-300 text-orange-700"}>
                  <td className="px-4 py-2">{order.orderId}</td>
                  <td className="px-4 py-2">{order.paymentId}</td>
                  <td className="px-4 py-2">{order.userName}</td>
                  <td className="px-4 py-2">{order.mobile}</td>
                  <td className="px-4 py-2">{order.address}</td>
                  <td className="px-4 py-2">
                    <ul>
                      {order.items.map((item) => (
                        <li
                          key={item.itemId}
                          className="flex flex-row items-center justify-around px-4"
                        >
                          <img src={item.image} width={100} className="p-2" />
                          <ul>
                            <li className="flex flex-row gap-2">
                              <div>x</div> <div>{item.quantity}</div>
                            </li>
                            <li>{item.selectedSize}</li>
                          </ul>
                        </li>
                      ))}
                    </ul>
                  </td>
                  <td className="px-4 py-2">{order.amount}</td>
                  <td className="px-4 py-2">{order.status}</td>
                  <td className="px-4 py-2">{order.trackingId}</td>
                  <td className="px-4 py-2">
                    {order.status === "captured" ? (
                      <div className="flex flex-col">
                        <div className="flex-row">
                          <input
                            type="text"
                            name="trackingId"
                            value={trackingIds[order.orderId] || ""}
                            onChange={(e) =>
                              setTrackingIds({
                                ...trackingIds,
                                [order.orderId]: e.target.value,
                              })
                            }
                            className="border-2 border-black"
                          />
                        </div>
                        <div className="flex flex-row gap-3 mt-2">
                          <button
                            onClick={() => dispatchOrder(order.orderId)}
                            className="bg-green-700 text-white px-3 hover:cursor-pointer hover:bg-green-800"
                          >
                            Dispatch
                          </button>
                          <button
                            onClick={() => cancelOrder(order.orderId)}
                            className="bg-red-700 text-white px-3 hover:cursor-pointer hover:bg-red-800"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    ) : (
                      <>{order.status}</>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
